import React, { useCallback } from 'react';
import { Platform, Pressable } from 'react-native';
import { Chat, IOStatusEnum } from '@matap/shared';
import styled from 'styled-components/native';
import { AppTextView } from '@/components/base/app.text.view';
import { AppImageView } from '@/components/base/app.image.view';
import { useFileAsset } from '@/hooks/use.file.asset';
import { useAssets } from '@/hooks/use.assets';
import { ChatFooterView } from './chat.footer.view';
import { DownloadUploadStateView } from './download.upload.state.view';
import { ChatContainer } from './chat.container';
import { AppCardView } from '@/components/base/app.card.view';
import { openViewer, wpVal } from '../../../utils';
import { useAppRouter } from '@/hooks/use.app.router';
import { ModalNamesEnum } from '@/constants/enums/modal.names.enum';

interface Props {
  chat: Chat;
  isSentByUser: boolean;
  temporary: boolean;
  onLongPress: (e: any) => void;
}
function BaseChatPdfView({ chat, isSentByUser, temporary, onLongPress }: Props) {
  const assets = useAssets();
  const { state } = useFileAsset(chat, temporary);
  const { navigateTo } = useAppRouter();

  const open = useCallback(() => {
    if (state?.localAddress) {
      if (Platform.OS === 'web') {
        openViewer(state.localAddress);
      } else {
        navigateTo(ModalNamesEnum.PdfView, { pdfPath: state.localAddress });
      }
    }
  }, [state, navigateTo]);

  return (
    <ChatContainer isSentByUser={isSentByUser} onLongPress={onLongPress}>
      <Pressable onPress={open} onLongPress={onLongPress}>
        <Container flexDirection={'row'} shadowColor={'#000'} shadowOpacity={0.07} shadowOffsetX={0} shadowOffsetY={2} blurRadius={6}>
          <IconContainer shadowColor={'#000'} shadowOpacity={0.1} shadowOffsetX={0} shadowOffsetY={2} blurRadius={6}>
            {state && state.state === IOStatusEnum.READY && <PDFIcon source={assets.images.pdf} variant={'circle'} />}
            {state && state.state !== IOStatusEnum.READY && <IOStatusView fileState={state} chatId={chat._id} />}
          </IconContainer>
          <NameView text={state?.fileName} numberOfLines={2} ellipsizeMode={'tail'} font={'app_english'} textAlign={'center'} />
        </Container>
      </Pressable>

      <ChatFooterView chat={chat} isSentByUser={isSentByUser} />
    </ChatContainer>
  );
}

// padding bottom same as ChatView's PaddingTop
const Container = styled(AppCardView)`
  padding: 10px;
  min-width: 170px;
  align-items: center;
  border-radius: 10px;
  background-color: #ffffff;
  max-width: ${wpVal(70)};
`;

const NameView = styled(AppTextView)`
  margin-left: 10px;
  margin-right: 10px;
  flex-grow: 1;
`;

const IconContainer = styled(AppCardView)`
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background-color: #fafafa;
`;

const PDFIcon = styled(AppImageView)`
  width: 70%;
  height: 70%;
  opacity: 1;
`;

const IOStatusView = styled(DownloadUploadStateView)`
  position: absolute;
  width: 45px;
  height: 45px;
`;

export const ChatPdfView = React.memo(BaseChatPdfView);
